import { get } from '../apiWrapper';

export interface PaymentIntent {
  clientSecret: string;
}

export const createPaymentIntentAPI = async (): Promise<PaymentIntent> => {
  const year = await get<PaymentIntent>(`/create-payment-intent`);
  return year;
};
